var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.699219,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#D2D6DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.1992V13.3992C24 12.2791 24 11.7191 23.782 11.2912C23.5903 10.9149 23.2843 10.609 22.908 10.4172C22.4802 10.1992 21.9201 10.1992 20.8 10.1992H19.2C18.0799 10.1992 17.5198 10.1992 17.092 10.4172C16.7157 10.609 16.4097 10.9149 16.218 11.2912C16 11.7191 16 12.2791 16 13.3992V14.1992M18 19.6992V24.6992M22 19.6992V24.6992M11 14.1992H29M27 14.1992V25.3992C27 27.0794 27 27.9195 26.673 28.5612C26.3854 29.1257 25.9265 29.5846 25.362 29.8722C24.7202 30.1992 23.8802 30.1992 22.2 30.1992H17.8C16.1198 30.1992 15.2798 30.1992 14.638 29.8722C14.0735 29.5846 13.6146 29.1257 13.327 28.5612C13 27.9195 13 27.0794 13 25.3992V14.1992",
    stroke: "#4D5761",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBIcon);
export default __webpack_public_path__ + "static/media/DeleteBIcon.a4fee9a26ab79fa09c0c697f0c4cc301.svg";
export { ForwardRef as ReactComponent };